const VIDEO_EXT = /\.(mp4|mov|m4v|webm|ogv)(\?|#|$)/i;

export function isVideoUrl(url: string | null | undefined): boolean {
  return !!url && VIDEO_EXT.test(url);
}

interface Props {
  url: string;
  alt?: string;
  className?: string;
  /** Show player controls (detail views); grids get a silent preview. */
  controls?: boolean;
  /** Cover shown on a video before it plays. */
  poster?: string | null;
}

/** Uploaded media can be a video; an <img> would show a broken image. */
export function MediaPreview({ url, alt = '', className = '', controls = false, poster }: Props) {
  if (isVideoUrl(url)) {
    return (
      <video
        src={url}
        className={className}
        controls={controls}
        muted={!controls}
        playsInline
        poster={poster || undefined}
        preload="metadata"
      />
    );
  }
  return <img src={url} alt={alt} className={className} loading="lazy" />;
}
